import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import ReportSelection from '../components/ReportComponents/ReportSelection/ReportSelection';
import ReportTabs from "../components/ReportComponents/ReportTabs";
import AutomaticReports from '../components/ReportComponents/AutomaticReports/AutomaticReports';
import PendingReports from "../components/ReportComponents/PendingReports/PendingReports";
import { bindActionCreators } from 'redux';
import ActionCreator from './../store/actions/index';
import { countHeightWhen2HeightToolbarUsed } from "../utils/helpers";
import { useWindowSize } from './../utils/hooks/useWindowResize';

const ReportView = props => {
    const { pendingReports } = props;
    const [tab, setTab] = useState(0);
    const { height } = useWindowSize();

    useEffect(() => {
        props.getReports();
        props.getPendingReportsOnOpen();
        props.getAutomaticReports();
        props.getGroups();

        const fetchPendingReportsInterval = setInterval(() => {
            props.getPendingReports();
        }, 60000);

        return () => {
            clearInterval(fetchPendingReportsInterval);
        };
    }, []);

    return (
        <div>
            <ReportTabs value={tab} onTabChange={setTab} pendingReportQuantity={pendingReports.length}/>
            {tab === 0 && <ReportSelection />}
            {tab === 1 && <AutomaticReports height={countHeightWhen2HeightToolbarUsed(height)} />}
            {tab === 2 && <PendingReports height={countHeightWhen2HeightToolbarUsed(height)} />}
        </div>
    );
};
ReportView.propTypes = {
    //redux
    pendingReports: PropTypes.array,
    getReports: PropTypes.func,
    getPendingReportsOnOpen: PropTypes.func,
    getAutomaticReports: PropTypes.func,
    getGroups: PropTypes.func,
    getPendingReports: PropTypes.func,
};

const mapStateToProps = state => ({
    pendingReports: state.reportReducer.pendingList
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(ReportView);